module.exports = __webpack_public_path__ + "static/devops-00e53c72fa4098af940842e1ab860c76.svg";